import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';

const UserUnavailabilityModal = ({ show, handleClose, onSave, unavailability }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        if (unavailability) {
            setStartDate(unavailability.start_date);
            setEndDate(unavailability.end_date);
        } else {
            setStartDate('');
            setEndDate('');
        }
        setError(null); // Clear errors when modal opens/changes
    }, [unavailability, show]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);

        if (!startDate || !endDate) {
            setError('Пожалуйста, выберите обе даты.');
            return;
        }

        if (new Date(startDate) > new Date(endDate)) {
            setError('Дата начала не может быть позже даты окончания.');
            return;
        }

        onSave({ start_date: startDate, end_date: endDate });
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{unavailability ? 'Редактировать период недоступности' : 'Добавить период недоступности'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="startDate">
                        <Form.Label>Дата начала</Form.Label>
                        <Form.Control
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="endDate">
                        <Form.Label>Дата окончания</Form.Label>
                        <Form.Control
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit">
                        {unavailability ? 'Сохранить изменения' : 'Добавить период'}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default UserUnavailabilityModal;
